import moment from "moment";
import FileSaver from "file-saver";
import { downloadInvoice } from "../../api/apimethods";
const InvoiceGridRow = ({ data }: { data: any; }) => {
  const handleDownload = async (invoiceId: string, fileName: string) => {
    try {
      const response = await downloadInvoice(invoiceId, fileName);

      const filedata = response?.data?.fileData;

      if (!filedata) {
        console.error("No file data returned from API");
        return;
      }

      // Convert Base64 to binary
      const byteCharacters = atob(filedata.trim());
      const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });
      FileSaver.saveAs(blob, fileName || "invoice.pdf");

    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  return (
    <tr>
      <td>{data?.invoiceNumber || ""}</td>
      <td>{data?.referenceNumber || ""}</td>
      <td>{data?.transactionID || ""}</td>
      <td>{moment(data?.invoiceDate).format("DD/MM/yyyy")}</td>
      <td>{data?.amountDue?.toFixed(2) || ""}</td>
      <td>{data?.paymentStatus || ""}</td>
      <td>
        {data?.id && (
          <button
            type="button"
            className="amendment"
            onClick={() => handleDownload(data?.id, data?.fileName)}
          >
            Download
          </button>
        )}
      </td>
    </tr>
  );
};

export default InvoiceGridRow;
